var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BlockButton",style:(_vm.cssVars)},[_c('div',{staticClass:"BlockButton-Button"},[_c('ce-text-editor',{key:_vm.keyToForceRender,attrs:{"value":_vm.block.content,"type":_vm.block.type,"on-change":_vm.onChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }